<template>
  <div>
    <EmergencyCallDashboard ref="dashboard" :fetch-aggregate="fetchMain115" :live-data="live115"
      :refresh-timer-in-minute="refreshTimerInMinute" />
  </div>
</template>
<script>

import throttle from 'lodash/throttle';
import EmergencyCallDashboard from './EmergencyCallDashboard.vue';
import Shared from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import Dashboard115Helper from '@/Helpers/115/Dashboard115Helper.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';

export default {
  name: 'Dashboards_115',
  title: 'داشبورد 115',
  components: { EmergencyCallDashboard },
  mixins: [Shared, DashboardMixin, Dashboard115Helper, snackBar, ShearedMixin],
  created() {

    this.throttledMainDashboard115 = throttle(this.getDataSignal, 4000, {
      leading: true,
      trailing: true,
    });

    this.throttledCurrentMissionsCount = throttle(this.getData, 4000, {
      leading: true,
      trailing: true,
    });

    this.$root.$refs.Dashboards115 = this;
    this.$mainSignalr.bus.$on('MainDashboard115', this.throttledMainDashboard115);
    this.$mobileSignalr.bus.$on('MainDashboard115', this.throttledMainDashboard115);

    this.$mainSignalr.bus.$on('CurrentMissionsCount', this.throttledCurrentMissionsCount);
    this.$mobileSignalr.bus.$on('CurrentMissionsCount', this.throttledCurrentMissionsCount);
  },
  mounted() {
    this.mounteLoding();
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('MainDashboard115', this.throttledMainDashboard115);
    this.$mobileSignalr.bus.$off('MainDashboard115', this.throttledMainDashboard115);

    this.$mainSignalr.bus.$off('CurrentMissionsCount', this.throttledCurrentMissionsCount);
    this.$mobileSignalr.bus.$off('CurrentMissionsCount', this.throttledCurrentMissionsCount);

    this.throttledMainDashboard115.cancel();
    this.throttledCurrentMissionsCount.cancel();
    delete this.$root.$refs.Dashboards115;
  },
  data() {
    return {
      newCall: false,
      liveSocket: null,
      activeMissionsInfo: null,
      refreshTimerInMinute: 1,
      missionListRefreshInFlight: false,
      missionListRefreshPending: false,

    };
  },
  computed: {
    live115() {
      if (!this.liveSocket && !this.activeMissionsInfo) return null;
      return {
        ...(this.liveSocket || {}),
        active: this.activeMissionsInfo ? this.activeMissionsInfo.value : null,
      };
    },
  },
  methods: {
    mounte: function () {
      if (this.$refs.dashboard) this.$refs.dashboard.loadAggregate();
      // this.getDataSignal()
      this.getData();
    },
    fetchMain115: function (retried) {
      return this.$store.dispatch('getDashboardMain115').then(() => {
        const dashboard = this.$store.state.dashboardModule;
        if (dashboard.successFlag) {

          const data = dashboard.dashboardMain115;

          if (data?.refreshTimerInMinute) {
            this.refreshTimerInMinute = data.refreshTimerInMinute;
          }

          return data;
          // return dashboard.dashboardMain115;
        }
        if (dashboard.errorStatus && retried !== true) {
          return this.$store.dispatch('refreshToken').then(() => {
            if (this.$store.state.userModule.successFlag) {
              return this.fetchMain115(true);
            }
            this.$router.push({ name: 'login' });
            throw new Error('unauthorized');
          });
        }
        throw new Error(dashboard.error || 'dashboard error');
      });
    },
    getDataSignal: function (data) {
      if (!data) return;
      const ms = (v) => new Date(String(v).replace(/(\.\d{3})\d+/, '$1')).getTime();
      const t = ms(data.currentDate);
      const prev = this.liveSocket ? ms(this.liveSocket.at) : NaN;
      if (isFinite(t) && isFinite(prev) && t < prev) return;
      this.liveSocket = {
        total: data.totalAgents,
        connected: data.loggedIn,
        free: data.available,
        queue: data.waiting,
        maxWait: data.longestHoldTime,
        avgWait: data.averageHoldTime,
        at: data.currentDate,
      };
    },
    getData: async function () {
      if (this.missionListRefreshInFlight) {
        this.missionListRefreshPending = true;
        return;
      }
      this.missionListRefreshInFlight = true;
      try {
        const res = await this.getNumberOfCurrentMissionsDashboardFunction();
        this.setActiveMissions115(res);
      } catch (error) {
        console.log('getData refresh error:', error);
      } finally {
        this.missionListRefreshInFlight = false;
        if (this.missionListRefreshPending) {
          this.missionListRefreshPending = false;
          this.getData();
        }
      }
    },
    setActiveMissions115: function (res) {
      const data = res && res.value === undefined && res.data ? res.data : res;
      if (!data || data.value === undefined || data.value === null) return;
      const t = new Date(data.currentDate).getTime();
      // پاسخ قدیمی‌تر از مقدار فعلی (مثلاً دو درخواست هم‌زمان) نادیده گرفته می‌شود
      if (this.activeMissionsInfo && isFinite(t) && t < this.activeMissionsInfo.t) return;
      this.activeMissionsInfo = { value: Number(data.value), t: isFinite(t) ? t : 0 };
    },
  },
};
</script>

<style lang="scss">
.bgCardAb_115 {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
}

.bgCardLineAb_115 {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0.2;
}


.cardTopStyle_115 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
  height: 100%;
  padding: 16px 24px;
  position: relative;
  z-index: 4;

  .iconStyle {
    background: white;
    padding: 10px !important;
    border-radius: 50% !important;
    box-shadow: 0px 5px 15px -5px var(--v-secondary-base)
  }

  .txt_title {
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }

  .txt_count {
    color: var(--v-darkColor-base);
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 1.3px;
    margin-right: auto;
  }
}

.styleCard_second_115 {
  height: 100%;

  .boxMain {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    height: 100%;


    .boxTxtIcon {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 20px;
      flex: 1;
      z-index: 3;

      .iconStyle {
        background: white;
        padding: 10px !important;
        border-radius: 50% !important;
        box-shadow: 0px 5px 15px -5px var(--v-darkColor-lighten2)
      }

      .item {
        display: flex;
        // flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 20px;

        .txt_count {
          color: #2d3748;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          letter-spacing: 1.3px;
        }

        .txt_title {
          color: #132440;
          font-size: 16px;
          font-style: normal;
          font-weight: normal;
        }

      }
    }
  }
}
</style>

<style scoped>
>>>.v-sheet.v-card {
  box-shadow: 2px 2px 10px -4px var(--v-darkColor-lighten1) !important;
}

.title-dashboards {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  font-weight: 500;
  color: var(--dark-color);
}

.main-dashboard-115-card {
  border-radius: 10px !important;
  border: 1px solid var(--dark-color) !important;
}

.body-card {
  overflow: hidden;
}

.body-card:hover {
  overflow-y: auto;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
  overflow: hidden;
}

.data-card_online {
  height: 100%;
  background: linear-gradient(250deg, var(--v-success-darken1) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card_offline {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-darken4) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card1 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-darken4) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-darken2) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-lighten1) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card4 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-lighten2) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

>>>.second-row-img {
  position: absolute;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}
</style>